import React, { useState, useEffect } from 'react';
/* Styles */
import './textRotator.css';

const TextRotator = ({ texts, interval }) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const rotationInterval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % texts.length);
    }, interval);

    return () => {
      clearInterval(rotationInterval);
    };
  }, [texts, interval]);

  return (
    <>
      <p className='texts'>{texts[currentIndex]}</p>
    </>
  );
};

export default TextRotator;
